import { render } from "./chequeDetail.vue?vue&type=template&id=bd75b87c&scoped=true"
import script from "./chequeDetail.vue?vue&type=script&lang=js"
export * from "./chequeDetail.vue?vue&type=script&lang=js"

import "./chequeDetail.vue?vue&type=style&index=0&id=bd75b87c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-accounting-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd75b87c"]])

export default __exports__